export function isElementViewable(elementId: string): boolean {
    if (document.hidden || document.visibilityState !== 'visible') {
        return false
    }

    const element = document.getElementById(elementId)

    if (!element) {
        return false
    }

    const { fullscreenElement } = document

    if (fullscreenElement && !fullscreenElement.contains(element)) {
        return false
    }

    const r = element.getBoundingClientRect()

    if (r.width === 0 || r.height === 0) {
        return false
    }

    const vpW = window.innerWidth
    const vpH = window.innerHeight

    const left = Math.max(0, r.left)
    const top = Math.max(0, r.top)
    const right = Math.min(vpW, r.right)
    const bottom = Math.min(vpH, r.bottom)

    const interWidth = Math.max(0, right - left)
    const interHeight = Math.max(0, bottom - top)
    const interArea = interWidth * interHeight
    const elemArea = r.width * r.height

    if (interArea / elemArea < 0.51) {
        return false
    }

    const cx = r.left + r.width / 2
    const cy = r.top + r.height / 2
    const topElement = document.elementFromPoint(cx, cy)

    return topElement === element || element.contains(topElement)
}
